import { Box, styled } from '@mui/material';
import { SxProps } from '@mui/system';

export const FooterContainer = styled('footer')(() => ({
  width: '100%',
}));

export const FixedBottom = styled(Box)(() => ({
  bottom: 30,
  position: 'fixed',
}));

export const anonymousLinkContainerStyles: SxProps = {
  maxWidth: 170,
};
